// extracted by mini-css-extract-plugin
export default {"notification":"styles_notification__nt-8c","show":"styles_show__3oQkp","overlay":"styles_overlay__YNlcB"};